// Converte dataURL OU base64 "cru" em Blob
function base64ToBlob(base64OrDataUrl, mimeFallback = 'application/octet-stream') {
    let base64 = base64OrDataUrl;
    let contentType = mimeFallback;
  
    // Se vier como dataURL (ex: "data:application/pdf;base64,AAA...")
    const dataUrlMatch = /^data:([^;]+);base64,(.*)$/i.exec(base64OrDataUrl);
    if (dataUrlMatch) {
      contentType = dataUrlMatch[1] || mimeFallback;
      base64 = dataUrlMatch[2];
    }
  
    // Decodifica base64 -> bytes
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  
  // Dispara download de um Blob com nome de arquivo
  function downloadBlob(blob, fileName = 'download') {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
   
  // Baixa usando base64 que está em memória
  export function downloadFromBase64({ base64, mimeType, fileName }) {
    if (!base64) throw new Error('Base64 não informado');
    const blob = base64ToBlob(base64, mimeType || 'application/octet-stream');
    downloadBlob(blob, fileName);
  } 